import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function ListsIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 70 70"
        {...props}
      >
        <path d="M37.87 24.41H17.5a1.25 1.25 0 0 1 0-2.5h20.37a1.25 1.25 0 0 1 0 2.5M37.87 31.62H17.5a1.25 1.25 0 0 1 0-2.5h20.37a1.25 1.25 0 0 1 0 2.5M31.66 39.85H17.5a1.25 1.25 0 0 1 0-2.5h14.16a1.25 1.25 0 0 1 0 2.5M53.62 42.44H36.14a1.25 1.25 0 0 1 0-2.5h17.48a1.25 1.25 0 0 1 0 2.5" />
        <path d="M44.89 51.18c-.69 0-1.25-.56-1.25-1.25V32.45a1.25 1.25 0 0 1 2.5 0v17.48c0 .69-.56 1.25-1.25 1.25" />
      </svg>
    </Icon>
  )
}
export default ListsIcon
